import React from 'react'
import {Spin, message, Button, Checkbox, Alert, Popconfirm} from 'antd';
import EssaModal from '@components/EssaModal/EssaModal';
import AuthBtn from "@components/HoverIcon/AuthBtn";
import Lang from "@components/Lang/Lang";
import {symbolMoneyUtil,isEmptyObject,isEmpty} from '@utils/utils';
import ModalCancelProductAction from "./ModalCancelProduct.action";
import ConfirmPayment from "../ModalConfirmPayment/ConfirmPayment";
import PropTypes from 'prop-types';
import dayjs from "dayjs";
import "./index.less"
/**
 * 取消商品 组件
 *
 * @author FJJ
 * @version 1.0
 *
 * History:
 * Date      Version Remarks
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
export default class ModalCancelProduct extends React.Component {
    static propTypes = {
        id:  PropTypes.number.isRequired,
    }
    static defaultProps = {
        id:"",
    };
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            loading: false,
            list:[],//行
            extra: {},
            selectOrder:{}, 
            showStepTwo:false,//显示第二步
            checkedObj:{
                checkedAll:false,
            },
            postIds:[]
        }
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    /**
     * 获取单个 详情*/
    getDeliveryListInfo(id) {
        this.loading(true)
        this.handleShowDetails(true)
        ModalCancelProductAction.post({
            id,
        },'/service/mg/delivery-management/delivery-list-info').then(res => {
            this.loading(false)
            if (res.data.success && res.data.valid) {
                let order = res.data.model || {}
                this.setState({
                    selectOrder: {
                        ...order,
                        ids: [order.id],
                    },
                    extra: res.data.extra,
                })
            } else {
                message.info(res.data.message);
            }
        })
    }
    handleShowDetails(flag=false){
        this.setState({
            showDetails:flag,
            checkedObj:{},//重置选择
            showStepTwo:false,// 重置 第一步
        })
    }
    /*
    * 是否进入第二步
    * */
    handleStepTwo(flag=false){
        this.setState({
            showStepTwo:flag,// 重置 第一步
        })
    }
    // 行编 多选框
    onChangeCheck(filed,flag){
        let {checkedObj={},selectOrder={}} = this.state;
        if(filed=="checkedAll"&&!flag){ // 取消全选 时
            checkedObj = {}
        }else checkedObj[filed] = flag;
        let iSkuNum = 0, iQuantity = 0;
        if(!isEmptyObject(checkedObj)){
            const list = selectOrder.goodItemVOS||[];
            list.forEach(item => {
                if(filed=="checkedAll"&&flag){//全选时
                    checkedObj[item.poItemId] = flag;
                    iSkuNum += 1
                    iQuantity += Number(item.deliveryQuantity)
                }else if(checkedObj[item.poItemId]) {
                    iSkuNum += 1
                    iQuantity += Number(item.deliveryQuantity)
                }
            })
            checkedObj["checkedAll"] = iSkuNum>0&&iSkuNum==list.length?true:false;
            checkedObj["iSkuNum"] = iSkuNum;
            checkedObj["iQuantity"] = iQuantity;
        }
        this.setState({
            checkedObj:checkedObj
        })
    }
    /*
    * 处理提交
    * @params handleCancel ture:直接取消(全选时),false：进入下一步
    *
    * 确认PO单 (先取消,再确认) http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8020
    * */
    handleOK(iSkuNum){
        if(iSkuNum>0){
            const {checkedObj={},selectOrder} = this.state;
            const list = selectOrder.goodItemVOS||[];
            let postIds = [], iTotal = 0, sCurrencySymbol="";
            list.forEach(item => {
                if(checkedObj[item.poItemId]) {
                    postIds.push(item.poItemId)
                    // iSkuNum += 1
                   if(isEmpty(sCurrencySymbol)) sCurrencySymbol = item.currencySymbol
                }else {
                    iTotal += Number(item.priceTotal);//非所选才计算金额
                }
            })
            if(checkedObj.checkedAll){ //全部取消 直接处理完关闭
                const { id,} = this.props;
                const postData = {
                    isAllCancel: 1,// 是否整单取消 1:整单取消,0非整单取消
                    poId:id
                }
                const sUrl = "/service/mg/sale/chinaOrder/bankCard/confirm-po";
                this.loading(true)
                ModalCancelProductAction.post(postData,sUrl).then((res={}) => {
                    this.loading(false)
                    const data = res.data;
                    if (data.success && data.valid) {
                        message.success(Lang({id:"YiZhengDanQuXiao",default:"已整单取消"}));
                        this.handleShowDetails();
                        if(this.props.refreshPage)this.props.refreshPage();
                    } else if(data.message) {
                        message.info(data.message);
                    }
                }).catch(err=>{
                    this.loading(false)
                })
            }else { // 部分取消 后弹出确认付款信息
                this.setState({
                    showStepTwo:true,
                    iTotal:iTotal,
                    sCurrencySymbol:sCurrencySymbol,
                    postIds:postIds
                })
            }
        }else message.warning(Lang({id:"QingXuanZeYaoQuXiaoDeShangPin",default:"请选择要取消的商品"}))
    }
    /*
     * 处理提交付款信息
     * @params handleCancel ture:直接取消(全选时),false：进入下一步
     * */
    handleOKPayment(){
        if(this.onRefConfirmPaymentChild){
            const values = this.onRefConfirmPaymentChild.getValues();
            if(!isEmptyObject(values)){
                const { id,} = this.props;
                const { postIds } = this.state;
                const postData = {...values,
                    isAllCancel: 0,// 是否整单取消 1:整单取消,0非整单取消
                    poId:id,
                    cancelPoItemIds:postIds
                }
                const sUrl = "/service/mg/sale/chinaOrder/bankCard/confirm-po";
                this.loading(true);
                ModalCancelProductAction.post(postData,sUrl).then((res={}) => {
                    this.loading(false)
                    const data = res.data;
                    if (data.success && data.valid) {
                        message.success(Lang({id:"QueRenDingDanChengGong",default:"确认订单成功"}));
                        this.handleShowDetails();
                        if(this.props.refreshPage)this.props.refreshPage();
                    } else if(data.message) {
                        message.info(data.message);
                    }
                }).catch(err=>{
                    this.loading(false)
                })
            }
        }
    }
    onRefConfirmPayment = (ref) =>this.onRefConfirmPaymentChild = ref;
    render() {
        const { id,} = this.props;
        const {loading, showDetails, checkedObj,selectOrder,showStepTwo,iTotal=0,sCurrencySymbol } = this.state;
        return (<>
                {<AuthBtn icon={"ri-file-close-line"}
                          tips = {Lang({id:"QuXiaoShangPin",default:"取消商品"})}
                          onClick={()=>this.getDeliveryListInfo(id)}
                    />}
                {/* 取消商品 弹窗*/}
                {showDetails&&<EssaModal title={showStepTwo?Lang({id:"QueRenFuKuanXinXi",default:"确认付款信息"}):Lang({id:"QuXiaoShangPin",default:"取消商品"})}
                                         open={showDetails}
                                         maskClosable={false}
                                         closable={showStepTwo?false:true}
                                         width={750}
                                        onCancel={()=>this.handleShowDetails()}
                                        footer={[
                                           (showStepTwo?<Button onClick={() => this.handleStepTwo()} key={"close"}>
                                                   {Lang({id:"ShangYiBu",default:"上一步"})}
                                               </Button>:<Button onClick={() => this.handleShowDetails()} key={"close"}>
                                              {Lang({id:"GuanBi",default:"关闭"})}
                                           </Button>),
                                            showStepTwo?<Popconfirm
                                                title={Lang({id: "SuoXuanXinXiShiFouYiJingYuKeHuQueRenGuo",default: "所选信息是否已经与客户确认过？"})}
                                                onConfirm={()=>this.handleOKPayment()}
                                                // onCancel={()=>this.handleShowDetails(false)}
                                                okText={Lang({id:'queren',default:'确认'})}
                                                cancelText={Lang({id:'QuXiao',default:'取消'})}>
                                                <Button type="primary" key={"handleOKPayment"}>{Lang({id: "QueDing",default: "确定"})}</Button>
                                            </Popconfirm>:(checkedObj.iSkuNum>0?<Popconfirm
                                                title={Lang({id: "QueDingYaoQuXiaoShangPinMa",default: "确定要取消商品吗？"})}
                                                onConfirm={()=>this.handleOK(checkedObj.iSkuNum)}
                                                // onCancel={()=>this.handleShowDetails(false)}
                                                okText={Lang({id:'queren',default:'确认'})}
                                                cancelText={Lang({id:'QuXiao',default:'取消'})}
                                            >
                                                <Button type="primary">{checkedObj.checkedAll?Lang({id: "ZhengDanQuXiao",default: "整单取消"}):Lang({id: "XiaYiBu",default: "下一步"})}</Button>
                                            </Popconfirm>:<Button type="primary" key={"handleOK"} onClick={()=>this.handleOK(checkedObj.iSkuNum)}>{Lang({id: "XiaYiBu",default: "下一步"})}</Button>)
                                        ]}>
                    {showStepTwo?<ConfirmPayment id={id}
                                                 onRef={this.onRefConfirmPayment}
                                                 currencySymbol={sCurrencySymbol}
                                                 orderNumber={selectOrder.orderNumber}
                                                 iTotal={iTotal} />:<Spin spinning={loading}>
                        <div className="cancelProWrap mt_14">
                            <div className="out-details-item">
                                <div className="details-info-box" data-flex="cross:center">
                                    <p className="details-info font-title fw_500 font_14 mb_8">
                                        <span className="mr_8">
                                            {Lang({id:"DingDan",default:"订单"})}<span className={"ml_4 mr_4"}>{selectOrder.orderNumber}</span>【{selectOrder.status}】
                                        </span>
                                        <span className="black45 font_12">{selectOrder.createTime?dayjs(selectOrder.createTime).format("YYYY-MM-DD HH:mm:ss"):'-'}</span>
                                    </p>
                                    <div className="details-info black89 fw_500 font_14">
                                        <span className="mr_8">
                                           {Lang({id:"KeHuBianHao",default:"客户编号"})}
                                        </span>
                                        <span className="mr_6">{selectOrder.buyerNumber}</span>
                                        <span className="black45 font_12">
                                            {selectOrder.email}
                                        </span>
                                    </div>
                                </div>
                                <div className={"black89 mt_16"}>
                                    <span className={"color-red2 mr_4"}>*</span>
                                    <span className={"fw_700"}>{Lang({id:"QingXuanZeYaoQuXiaoDeShangPin",default:"请选择要取消的商品"})}</span>
                                </div>
                                <div className="details-item-th black45 font_13 mt_8" data-flex="cross:center">
                                    <span className="flex1">
                                        <Checkbox checked={checkedObj.checkedAll} onChange={()=>this.onChangeCheck("checkedAll",!checkedObj.checkedAll)} />
                                        <span className={"ml_12"}>{Lang({id:"ShangPinXinXi",default:"商品信息"})}</span>
                                    </span>
                                    <span className="text-right">{Lang({id:"XiangShu",default:"箱数"})}</span>
                                </div>
                                {selectOrder.goodItemVOS&&selectOrder.goodItemVOS.map((item, index) => (<div key={index} className="flex-item-between details-goods font_14">
                                        <div className={"flex-item"}>
                                            <Checkbox checked={checkedObj[item.poItemId]}
                                                      key={"check_"+item.poItemId}
                                                      onChange={()=>this.onChangeCheck(item.poItemId,!checkedObj[item.poItemId])}/>
                                            <div className={"ml_12"}>
                                                <div className={"flex-item"}>
                                                    <div>
                                                        <div className={"proPic"}>
                                                        <img src={item.picUrl} alt=""/>
                                                        </div>
                                                    </div>
                                                    <div className={"ml_12"}>
                                                        <div className={"color-black wTitle"}>{item.skuName}</div>
                                                        <div className={"mt_16 font_12 flex-item black45"}>
                                                            <div className="mr_24">
                                                                <div>{Lang({id:"ZhuangLiang",default:"装量"})} {item.outboxCapacity}/{Lang({id:"WaiXiang",default:"外箱"})}</div>
                                                                <div className="mt_4">{Lang({id:"CaiGouJia",default:"采购价"})}  {symbolMoneyUtil(item.purchasePrice,item.currencySymbol)}</div>
                                                            </div>
                                                            <div>
                                                                <div>{Lang({id:"TiJi",default:"体积"})}  {item.outBoxVolume} m³</div>
                                                                <div  className="mt_4">{Lang({id:"ShangPinBianHao",default:"商品编号"})}  {item.skuNo}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {checkedObj[item.poItemId]?<div className={"mt_4"}>
                                                    <span className={"labelOut"}>{Lang({id:"KeHuBuYaoLe",default:"客户不要了"})}</span>
                                                </div>:null}
                                            </div>
                                        </div>
                                        <div className={"text-right"}>
                                            <div className="fw_700">x {item.deliveryQuantity}</div>
                                            <div className="mt_4">{item.skuOutBoxVolumeTotal} m³</div>
                                            <div className="mt_4">{item.skuGrossWeightTotal||0} kg</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="mt_16 font-title fw_700 font_14 lineH_20" >
                                <p className="color-black" data-flex="main:right">{Lang({id:"HeJi",default:"合计"})}
                                {selectOrder.skuNum} {Lang({id:"Kuan",default:"款"})}，{selectOrder.quantity} {Lang({id:"Xiang",default:"箱"})}</p>
                                <p className={"black89 mt_6"} data-flex="main:right"><span className="font_13">{selectOrder.outBoxVolumeTotal} m³</span>，<span className="font_13">{selectOrder.grossWeightTotal} kg</span></p>
                            </div>
                            {!isEmptyObject(checkedObj)&&checkedObj.iSkuNum>0?<div className={"mt_16"} key={"alertCheck"}>
                                <Alert message={Lang({id:"HeJiQuXiao",default:"合计取消"})+" "+Lang({id:"NKuanNXiang",default:"{0} 款，{1} 箱",params:[checkedObj.iSkuNum,checkedObj.iQuantity]})} type="warning" showIcon />
                            </div>:null}
                        </div>
                    </Spin>}
                </EssaModal>}

            </>
        )
    }
}